import cn from 'classnames'
import { useSnapshot } from 'valtio'

import { type ReactElement } from 'react'
import { DEFAULT_LIMIT } from '../../../../../shared/utils/apiUtils'
import { customersProxy } from '../../../../../shared/proxies/customersProxy'
import { executeCustomersSearch } from '../../../../../shared/apiUtils/executeCustomersSearch'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'

const onLoadMore = (): void => {
  customersProxy.filters.offset += DEFAULT_LIMIT
  void executeCustomersSearch({ appendRecords: true, displayLoader: false })
}

export function CustomerTableFooter (): ReactElement {
  const { hasMore } = useSnapshot(customersProxy)
  const { siteTheme } = useSnapshot(proxyGlobalAuth)

  return (
    <div className={cn(siteTheme.tableFooterColors.classes, 'text-center p-6 relative')}>
      <div
        role="button"
        className={
          cn('font-semibold underline opacity-90 ',
            !hasMore && 'invisible'
          )
        }
        onClick={onLoadMore}
      >
        View More Customers
      </div>
    </div>
  )
}
